import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IUninstallReason } from './aggregatedUninstallTable';
import moment from 'moment';
import { useQuery } from 'react-query';
import { globalEnv } from '../../../../config/baseConfig';
import axios from 'axios';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { UserElement } from './uninstallReasonsModal';

interface IDetailedUninstallReason extends IUninstallReason {
	possibleUser: any;
}

export const AggregatedUninstallReasonsModalContent = ({
	reason,
	detailedReasons,
	extensionId
}: {
	reason: string;
	detailedReasons?: IUninstallReason[];
	extensionId?: string;
}) => {
	const [reasons] = useState<IDetailedUninstallReason[]>(
		detailedReasons
			? detailedReasons.map((dr) => ({ ...dr, possibleUser: null }))
			: []
	);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	async function fetchSettingsData() {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data } = await axios.get(
			`${globalEnv.BASE_URL}/settings/topic-style`,
			config
		);
		return data;
	}

	useQuery([], () => fetchSettingsData(), {
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		staleTime: 5000
	});

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                 w-11/12 h-full md:h-auto ml-8 px-4 py-2 max-h-[90%] mt-10 flex flex-col"
		>
			<section
				className="relative bg-white w-full max-h-screen overflow-y-auto h-screen
                                dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
			>
				<div className="mx-auto max-w-lg w-10/12 my-10">
					<UserElement reason={reason} extensionId={extensionId} />
				</div>

				{detailedReasons != null && (
					<div className="mx-3">
						<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white mb-3 ">
							Detailed Reasons:
						</div>

						{reasons.map((item: IUninstallReason) => (
							<div className="flex flex-row mb-2 dark:bg-gray-700 rounded-xl">
								<div className="w-1/12"></div>
								<div className="font-medium text-sm my-2 text-gray-800 dark:text-white w-10/12">
									{item.uninstallReasonDetails}
								</div>
								<div className="w-1/12 text-sm my-2 text-gray-800 dark:text-white">
									{moment(item.createdAt).format('MM/DD/YYYY HH:mm')}
								</div>
								<hr className="sidebar-hr" />
							</div>
						))}
					</div>
				)}
			</section>
		</div>
	);
};
